import { render, staticRenderFns } from "./BaseView.vue.html?vue&type=template&id=e2249382&"
import script from "./BaseView.component.js?vue&type=script&lang=vueJs&"
export * from "./BaseView.component.js?vue&type=script&lang=vueJs&"
import style0 from "./BaseView.scss?vue&type=style&index=0&prod&lang=vueScss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports